import gql from 'graphql-tag'

import { PublicExpoAuthenticateVisitorMutation } from '../../../types/api'

export const authenticateVisitor = {
  mutation: gql`
    mutation publicExpoAuthenticateVisitor($visitor: ID!, $code: String!) {
      publicExpoAuthenticateVisitor(visitor: $visitor, code: $code) {
        token
        visitor {
          first_name
          last_name
          email
          optinRegistration
          slot {
            id
            opening_hour
            closing_hour
            remaining_capacity
          }
          event {
            ...PublicExpoEventFields
            translations {
              ...PublicExpoEventTranslationFields
            }
            slots {
              ...PublicExpoEventSlotFields
            }
          }
        }
      }
    }

    fragment PublicExpoEventFields on PublicExpoEvent {
      id
      uuid
      name
      slug
      description
      frontTitle
      frontImage
      frontDescription
      registration_closing_at
      locales {
        ...LocaleFields
      }
    }

    fragment PublicExpoEventTranslationFields on PublicExpoEventTranslation {
      locale {
        ...LocaleFields
      }
    }

    fragment PublicExpoEventSlotFields on PublicExpoEventSlot {
      id
      opening_hour
      closing_hour
      remaining_capacity
      bookable
    }

    fragment LocaleFields on Locale {
      id
      iso
      label
    }
  `,
  transformer: (response: PublicExpoAuthenticateVisitorMutation) => {
    return response.publicExpoAuthenticateVisitor
  },
}
